import { NavigationContext } from 'src/types/account'

import { LinkOption } from '../types'
import { MobileAccountMenu } from './MobileAccountMenu'

export interface MobileNavigationProps {
  className?: string
  links: LinkOption[]
  navigationContext: NavigationContext
}

export const MobileNavigation = ({
  className = '',
  links,
  navigationContext
}: MobileNavigationProps) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={e => {
        e.stopPropagation()
      }}
      className={`sm:min-w-85 sm:max-w-85 max-h-[calc(100%-80px)] overflow-auto absolute bg-linen right-0 w-full top-20 z-100 shadow-2xl ${className}`}
    >
      <MobileAccountMenu links={links} navigationContext={navigationContext} />
    </div>
  )
}
